/*
 *   File : refund-policy.js
 *   Author : https://evoqins.com
 *   Description : Refund policy page
 *   Integrations : 
 *   Version : 1.0.0
*/

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

// Components
import { TextButton } from "../../Component/Buttons";
import { _scrollToTop } from "../../Helper";

// Custom data
const DATA = [
    {
        id: 1,
        title: "Introduction",
        des: "Welcome to Indvestment! These Terms and Conditions govern your use of our app and services. By accessing or using Indvestment, you agree to be bound by these terms.",
        type: 1,
    },
    {
        id: 2,
        title: "Use of Services",
        des: "Indvestment provides investment opportunities through curated stock baskets. By using our service, you acknowledge that investments are subject to market risks, including loss of principal.",
        type: 1,
    },
    {
        id: 3,
        title: "User Responsibilities",
        data: [
            {
                title: "Eligibility",
                des: "You must be at least 18 years old to use Indvestment."
            },
            {
                title: "Account Security",
                des: "You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account."
            },
            {
                title: "Compliance",
                des: "You agree to comply with all applicable laws and regulations."
            },
        ],
        type: 2,
    },
    {
        id: 4,
        title: "Intellectual Property",
        des: "All content on the Indvestment app, including text, graphics, logos, and software, is the property of Indvestment or its licensors and is protected by copyright and other intellectual property laws.",
        type: 1,
    },
    {
        id: 5,
        title: "Limitation of Liability",
        des: "Indvestment will not be liable for any indirect, incidental, or consequential damages arising out of or in connection with your use of the service.",
        type: 1,
    },
    {
        id: 6,
        title: "Termination",
        des: "We reserve the right to suspend or terminate your account at any time, with or without cause, and with or without notice.",
        type: 1,
    },
    {
        id: 7,
        title: "Changes to Terms",
        des: "Indvestment reserves the right to modify these terms at any time. We will notify you of any changes by posting the new terms on our app and website.",
        type: 1,
    },
    {
        id: 8,
        title: "Governing Law",
        des: "These terms shall be governed by and construed in accordance with the laws of the jurisdiction in which Indvestment operates.",
        type: 1,
    },

];

function RefundPolicy(props) {

    const navigate = useNavigate();

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();
    }, []);

    const _handleBack = () => {
        navigate(-1);
        props.handlePublicRouter();
    };


    return (
        <>
            <TextButton name="Refund Policy"
                labelClass="e-font-16-res"
                icon={true}
                type={2}
                onPress={_handleBack} />
            <div className="p-3 card-box-shadow e-bg-white mt-4 border-radius-8 d-flex flex-column gap-3">
                {
                    DATA.map((item, key) => (
                        <div key={key} className={DATA.length === key + 1 ? "margin-22px-bottom" : ""}>
                            <h6 className="mb-2 e-text-chinese-black e-alt-font-lato e-font-weight-600 e-font-16 line-height-20px e-letter-spacing-min-point-1px">
                                {item.title}
                            </h6>
                            {
                                item.type == 1 ?
                                    <p className="mb-0 e-text-outer-space e-alt-font-lato e-font-weight-400 e-font-14 line-height-22px">
                                        {item.des}
                                    </p>
                                    :
                                    <ul className="list-style-type-lower-roman ps-0 m-0">
                                        {
                                            item.data.map((data, i) => (
                                                <li key={i + 1}>
                                                    <span className="e-text-outer-space e-alt-font-lato e-font-weight-600 e-font-14 line-height-20px">
                                                        {data.title}
                                                    </span>
                                                    {
                                                        ": "
                                                    }
                                                    <span className="e-text-outer-space e-alt-font-lato e-font-weight-400 e-font-14 line-height-20px">
                                                        {data.des}
                                                    </span>
                                                </li>
                                            ))
                                        }
                                    </ul>
                            }
                        </div>

                    ))
                }

            </div>
        </>
    )
}

export default RefundPolicy;